export function hyphenate(str: string): string {
  return str.toLowerCase().replace(/\W+/g, '-');
}

export function truncate(str: string, limit: number): string {
  const ACTUAL_LIMIT = limit - 3;

  if (!str || str.length < ACTUAL_LIMIT) {
    return str;
  }

  return `${str.substr(0, ACTUAL_LIMIT)}...`;
}

export interface FullName {
  first?: string;
  last?: string;
}

export function splitNameParts(name: string): FullName {
  const [, first, last] =
    name.match(/^(\S+)(?:\s+)?(.*)?$/) || ([] as RegExpMatchArray);

  return { first, last };
}



// WEBPACK FOOTER //
// ./src/app/utils/string.ts